import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import frTranslation from './fr-FR.json';
import enTranslation from './en-EN.json';


i18n.use(initReactI18next).init({
    resources: {
      fr: {
        translation: frTranslation
      },
      en: {
        translation: enTranslation
      }
    },
    fallbackLng: localStorage.getItem('language') || "fr",
    debug: true,
});

export default i18n;  